<template>
  <div>
    <div v-if="loginLoading">
      <LoginLoader />
    </div>
    <div v-show="!loginLoading">
      <div class="wrrapper--container">
        <div :class="[isNavOpen ? 'open-sidebar' : 'content-area', 'content']">
          <slot />
        </div>
        <div class="sidebar-area">
          <Sidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "../components/Sidebar";
import { mapGetters, mapActions } from "vuex";
import LoginLoader from "../components/LoginLoader.vue";

export default {
  components: {
    Sidebar,
    LoginLoader
  },
  methods: {
    ...mapActions({
      validateSession: "auth/validateSession"
    })
  },
  computed: {
    ...mapGetters({
      isNavOpen: "isNavOpen",
      loginLoading: "auth/loginLoading",
      userInfo: "auth/userInfo",
      isLoggedIn: "auth/isLoggedIn",
      validateSessionStatus: "auth/validateSessionStatus"
    })
  },
  async mounted() {
    if (this.isLoggedIn) {
      const payload = {
        userId: this.userInfo.id,
        sessionId: this.userInfo.currentUserSession.sessionId
      };
      await this.validateSession({ vm: this, payload });
      console.log(this.validateSessionStatus, "validateSessionStatus");

      if (this.validateSessionStatus.validated !== true) {
        this.$store.dispatch("auth/logout", { vm: this }).then(() => {
          this.$router.push("/");
        });
      }
    }
  }
};
</script>
q
<style scoped>
.wrrapper--container {
  margin-top: 1.5rem;
}

.open-sidebar {
  margin: 0 24px 0 16.25rem;
  transition: margin 0.3s ease-in-out;
}

.content-area {
  margin: 0px 24px 0 6rem;
  transition: margin 0.3s ease-in-out;
}
</style>
